import { createBaseAction } from '@essent/common';
import type { GetConsentGroupResponse } from '@integration/api-client/consent';

export const submitPutConsents = createBaseAction(
  '[Consent] Submit put consents'
);

export const updateConsentStoreAction = createBaseAction<
  GetConsentGroupResponse[]
>('[Consent] Update consent store');
